<template>
    <div v-if="hackReset" @keydown.enter="keyDown('enter')">
       <template  v-if="type === 'Divider'">
            <Divider
            :orientation="config.orientation"
            :dashed="config.dashed"
            :type="config.vtype"
            :id="config.id"
        >
            {{ config.label }}
        </Divider>
        </template>
        <template  v-else-if="type === 'NumberRangeBox'">
            <NumberRangeBox
            ref="myControl"
            :fatherSvalue="svalue"
            :fatherEvalue="evalue"
            @input="input"
            :config="config"
            ></NumberRangeBox>
        </template>
         <template  v-else-if="type === 'DateRangeBox'">
            <DateRangeBox
            ref="myControl"
            :fatherSvalue="svalue"
            :fatherEvalue="evalue"
            @input="input"
            :config="config"
            ></DateRangeBox>
        </template>
         <template  v-else-if="type === 'PopTextBox'">
            <PopTextBox
            ref="myControl"
            :fatherValue="value"
            :fatherText="text"
            @input="input"
            :config="config"
            ></PopTextBox>
        </template>
        <template  v-else-if="type === 'PictureBox'">
            <PictureBox
            ref="myControl"
            v-if="config.multiSelect !== true"
            :fatherValue="value"
            @input="input"
            :config="config"
            :readOnly="readOnly"
            :showStyle="config.showStyle"
        ></PictureBox>
        <PictureBox
            ref="myControl"
            v-else
            :config="config"
            :readOnly="readOnly"
            :showStyle="config.showStyle"
        ></PictureBox>
        </template>
        <template  v-else-if="type === 'VideoBox'">
            <VideoBox
            ref="myControl"
            v-if="config.multiSelect !== true"
            :fatherValue="value"
            @input="input"
            :config="config"
            :readOnly="readOnly"
            :showStyle="config.showStyle"
        ></VideoBox>
        <VideoBox
            ref="myControl"
            v-else
            :config="config"
            :readOnly="readOnly"
            :showStyle="config.showStyle"
        ></VideoBox>
        </template>
        <template  v-else>
            <component :is="type"  ref="myControl" :fatherValue="value" :readOnly="readOnly" @input="input" :config="config"/>
        </template>
    </div>
</template>

<script>
import proBase from './probase';
export default {
    name: 'ControlBox',
    mixins: [proBase],
};
</script>



// WEBPACK FOOTER //
// src/components/base/controlbox.vue